<div class="container">
    <div class="col-md-12">
        <div id="Header">
            <img src="./assets/images/logo_woden.png" alt="">
        </div>
    </div>
    <div class="col-md-12">
        <h2>Agenda-pro Filtrar Clientes</h2>
        <p-accordion>
            <p-accordionTab header="Filtro clientes">
                <p-card>
                    <form>
                        <div class="row form-group">
                            <div class="col-md-4">
                                <label for="">Fecha Inicio</label>
                                <input type="text" class="form-control">
                            </div>
                            <div class="col-md-4">
                                <label for="">Fecha Fin</label>
                                <input type="text" class="form-control">
                            </div>
                            <div class="col-md-4">
                                <label for="">Concepto</label>
                                <input type="text" class="form-control">
                            </div>
                        </div>
                        <div class="row form-group">
                            <div class="col-md-4">
                                <button class="btn btn-success btn-sm">
                                    Buscar
                                    <span class="fa fa-search"></span>
    
                                </button>
                            </div>
                        </div>
                    </form>
                </p-card>
            </p-accordionTab>
        </p-accordion>
    </div>
    <div class="col-md-12 table">
        <p-table #dt [columns]="cols" [value]="listreportAgenda" [resizableColumns]="true" columnResizeMode="expand" [autoLayout]="true">
            <ng-template pTemplate="caption">
                <div class="ui-helper-clearfix">
                    <button type="button" pButton icon="fa fa-file-o" iconPos="left" label="Exportar" (click)="dt.exportCSV()" style="float:right"></button>
                </div>
            </ng-template>
            <ng-template pTemplate="header" let-columns>
                <tr>
                    <th *ngFor="let col of columns">
                        {{col.header}}
                    </th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-rowData let-columns="columns">
                <tr>
                    <td *ngFor="let col of columns">
                        {{rowData[col.field]}}
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</div>